<template>
  <layout>
    <page-header :header="$t('bookings.create')" />
    <div class="content">
      <b-card v-if="false">
        <h4>{{ $t('bookings.select_account') }}</h4>
        <v-select
          v-model="selected"
          label="name"
          :filterable="false"
          :options="users"
          :placeholder="$t('general.type_to_search')"
          @search="fetchUsersWithDebounce"
        >
          <template slot="option" slot-scope="user">
            {{ user.name }} &lt;{{ user.email }}&gt;
          </template>
          <template slot="selected-option" slot-scope="user">
            {{ user.name }} &lt;{{ user.email }}&gt;
          </template>
        </v-select>
      </b-card>
      <div v-if="$settings._loaded && $account">
        <BookingForm v-if="$allows('administer')" @saved="onBookingSave" />
        <BookingWidget
          v-else
          :user="selectedUser"
          is-admin
          :allow-price-override="allowPriceOverride"
        />
      </div>
    </div>
  </layout>
</template>

<script>
import { mapState } from 'vuex'
import { AdminApi } from 'stylemix-vue-admin'
import debounce from 'lodash/debounce'
import vSelect from 'vue-select'

const usersApi = new AdminApi('users')

export default {
  components: {
    BookingWidget: () => import('./BookingWidget.vue'),
    BookingForm: () => import('./Form.vue'),
    vSelect,
  },

  data() {
    return {
      selected: null,
      users: [],
    }
  },

  computed: {
    ...mapState('admin-auth', ['token']),

    selectedUser() {
      return { ...this.selected, token: this.token }
    },
    allowPriceOverride() {
      if (this.$allows('administer')) {
        return this.$settings.booking_allow_price_override || false
      }

      return false
    },
  },

  created() {
    this.fetchUsersWithDebounce = debounce(this.fetchUsers, 300)
  },

  methods: {
    fetchUsers(query, loading) {
      if (!query) {
        return
      }
      loading(true)

      usersApi
        .setParameters({
          context: 'booking',
          query,
        })
        .all()
        .then(({ data: users }) => {
          this.users = users
          loading(false)
        })
    },

    onBookingSave({ data: booking }) {
      if (['processing', 'complete'].indexOf(booking.status) !== -1) {
        this.$router.push({ name: 'bookings.tasks' })
        return
      }

      this.$router.push({ name: 'bookings' })
    },
  },
}
</script>
